import { useCrossTabSessionNoticeStore } from '@/store/use-cross-tab-session-notice-store';
import {
  clearSoulMapLoginFlow,
  getAuth0LogoutReturnTo,
  isSoulMapLoginPage,
} from '@/utils/soulmap-auth';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useState } from 'react';

export function CrossTabSessionChangedModal() {
  const { isOpen, reason, newUserEmail } = useCrossTabSessionNoticeStore();
  const { isAuthenticated: isAuth0Authenticated, logout } = useAuth0();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const onSoulMapLanding = isSoulMapLoginPage();

  const title =
    reason === 'signed_out'
      ? 'Signed out in another tab'
      : onSoulMapLanding
        ? 'Signed in in another tab'
        : 'Account changed in another tab';

  const message =
    reason === 'signed_out'
      ? 'You were signed out in another browser tab. Refresh this page to sign in again.'
      : onSoulMapLanding
        ? 'You signed in in another browser tab. Refresh this page to continue signing in with Google.'
        : newUserEmail
          ? `You signed in as ${newUserEmail} in another browser tab. Refresh this page to continue with that account.`
          : 'You signed in with a different account in another browser tab. Refresh this page to continue.';

  const handleRefresh = async () => {
    if (isRefreshing) return;
    setIsRefreshing(true);

    if (isSoulMapLoginPage()) {
      clearSoulMapLoginFlow();

      if (isAuth0Authenticated) {
        try {
          await logout({
            openUrl: false,
            logoutParams: {
              returnTo: getAuth0LogoutReturnTo(window.location.pathname, {
                markPostLogout: false,
              }),
            },
          });
        } catch (error) {
          console.error('Failed to clear Google session before refresh:', error);
        }
      }
    }

    window.location.reload();
  };

  return (
    <Modal
      isOpen={isOpen}
      isDismissable={false}
      hideCloseButton
      placement="center"
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>
        <ModalBody>
          <p className="text-default-600">{message}</p>
        </ModalBody>
        <ModalFooter className="flex justify-end border-t mt-4">
          <Button
            color="primary"
            isLoading={isRefreshing}
            onPress={() => {
              void handleRefresh();
            }}
          >
            Refresh this page
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
